import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb, Accordion } from "react-bootstrap";
import Topnav from "../common/Topnav";
import Menubar from "../common/Menubar";
import { Link } from "react-router-dom";
import Footer from "../common/footer";
import Servicesslidebaar from "../sidebars/ServicesSidebar";
import EnquiryNow from "../common/EnquiryNow3";

const StudentCouncil = () => {
  const [modalShow, setModalShow] = React.useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Topnav />
      <Menubar />
      <div className="comminnerbackimage innerbackimage">
        <div className="text_banners_abcds">
          <h1> Student Council</h1>
          <div onClick={() => setModalShow(true)}>
            <span>
              <a className="btn btn-primary" href="#" role="button">
                Apply Now
              </a>
            </span>
          </div>
          <EnquiryNow show={modalShow} onHide={() => setModalShow(false)} />
        </div>
      </div>

      {/* container */}
      <Container className="About_us11">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">Home</Link>
          </Breadcrumb.Item>

          <Breadcrumb.Item active>Student Council</Breadcrumb.Item>
        </Breadcrumb>
        <Row>
          <Servicesslidebaar />
          <Col lg={9}>
            <h2 className="linkabout123">Student Council</h2>
            <div className="position-relative card table-nowrap table-card">
              <div className="table-responsive committe-table">
                <table className="table mb-0">
                  <thead className="small text-uppercase bg-body text-muted bg-secondary">
                    <tr>
                      <th>Name of Member</th>
                      <th>Designation</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="small">Bhuneshwar</td>
                      <td className="small">President</td>
                    </tr>
                    <tr>
                      <td className="small">Dr. B. P. Bhol</td>
                      <td className="small">Registrar</td>
                    </tr>
                    <tr>
                      <td className="small">Dr. Sandeep Kumar Sahu</td>
                      <td className="small">Proctor</td>
                    </tr>
                    <tr>
                      <td className="small">Dr. N. K. Swamy</td>
                      <td className="small">Dean Academics</td>
                    </tr>
                    <tr>
                      <td className="small">Ahilya</td>
                      <td className="small">Student Representative</td>
                    </tr>
                    <tr>
                      <td className="small">Urvashi</td>
                      <td className="small">Student Representative</td>
                    </tr>
                    <tr>
                      <td className="small">Dhanraj</td>
                      <td className="small">Student Representative</td>
                    </tr>
                    <tr>
                      <td className="small">Yashvant</td>
                      <td className="small">Student Representative</td>
                    </tr>
                    <tr>
                      <td className="small">Chameli Sahu</td>
                      <td className="small">Student Representative</td>
                    </tr>
                    <tr>
                      <td className="small">Yugal Ratre</td>
                      <td className="small">Student Representative</td>
                    </tr>
                    <tr>
                      <td className="small">Vikas</td>
                      <td className="small">Student Representative</td>
                    </tr>
                    <tr>
                      <td className="small">Jivan Lal</td>
                      <td className="small">Student Representative</td>
                    </tr>
                    <tr>
                      <td className="small">Thakeshwar Nayak</td>
                      <td className="small">Student Representative</td>
                    </tr>
                    <tr>
                      <td className="small">Devendra Kumar</td>
                      <td className="small">Student Representative</td>
                    </tr>
                    <tr>
                      <td className="small">Preeti</td>
                      <td className="small">Student Representative</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
};

export default StudentCouncil;
